import React from "react";
import { Tab } from "./components";
import style from "./style/Tabs.module.scss";

export const Tabs = ({ tabs, classes = {}, activeTab, onTabSwitch }: TabsProps): JSX.Element => {
  return (
    <nav className={[style.tabs, classes?.root || ''].join(" ")}>
      <ul>
        {tabs.map((tab) => (
          <Tab
            key={tab.id}
            id={tab.id}
            label={tab.label}
            isActive={activeTab === tab.id}
            classes={{
              tab: classes.tab,
              tabActive: classes.tabActive,
            }}
            onClick={() => onTabSwitch(tab.id)}
          />
        ))}
      </ul>
    </nav>
  );
};

export interface TabsProps {
  /**
   * Tabs collection.
   */
  tabs: Array<{
    id: string;
    label: string;
  }>;
  /**
   * Optional custom class overrides.
   */
  classes?: {
    root?: string;
    tab?: string;
    tabActive?: string;
  };
  /**
   * The ID of the currently active tab.
   */
  activeTab?: string;
  /**
   * Callback function triggered when a tab is clicked.
   */
  onTabSwitch: (tabId: string) => void;
}
